import { PageContentViewModel } from "@/lib/vm/page-content-viewmodel";
import renderReactComponent from "@/react/render-react-component";
import type { Root } from "react-dom/client";
import template from "./communications.pug";

export class NewCommunicationsViewModel extends PageContentViewModel {
   private root: Root | null;
   constructor() {
      super(template());
      this.root = null;
   }

   addedToParent(): void {
      this.root = renderReactComponent("react-communications-mount", "CommunicationsContainer", {});
   }

   removedFromParent(): void {
      if (this.root) {
         this.root.unmount();
      }
   }
}
